import { IApplicationState } from '../../types/redux';

export function getMedia(state: IApplicationState) {
  return state.newbuilding.media;
}
